import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "delivery-address-copy" }


const __default__ = {
  name: 'deliveryAddressCopy'
};

import { computed, ref, watch, reactive, nextTick, onMounted } from 'vue';
import { ShowSearchType } from 'ant-design-vue/lib/cascader';
import {OioFormItem} from "@kunlun/vue-ui-antd";

interface IProps {
  addressOptions: any[];
  onChange: (value: any) => void;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    addressOptions: null,
    onChange: null
  },
  setup(__props: any) {

const props = __props as { addressOptions: any[], onChange: (value: any) => void }

const deliveryAddressCopy = ref("");



const getPopupContainer = () => document.getElementById('delivery-address-copy');

const onDeliveryAddressCopyChange = async (val: string) => {
  
  // deliveryAddressCopy.value = props.addressOptions?.find((item) => item.id === val) ?? {};
  // props.deliveryAddressCopy = val
  deliveryAddressCopy.value = val;
  props.onChange(props.addressOptions?.find((item) => item.id === val) ?? {});
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_select, {
      class: "oio-select",
      value: deliveryAddressCopy.value,
      options: __props.addressOptions,
      showSearch: "",
      placeholder: "选择地址",
      fieldNames: {
              label: 'labelTitle',
              value: 'id'
            },
      onSelect: onDeliveryAddressCopyChange,
      optionFilterProp: "labelTitle",
      getPopupContainer: getPopupContainer
    }, null, 8, ["value", "options"])
  ]))
}
}

})